import { Big } from 'big.js';
import { EnumWaterBottleDelivery, PricingItem, QuoteService, parseBig } from 'quote-domain-core';
import { PricingItemCorridorService } from '../pricing-item/pricing-item-corridor-service';
import { PricingItemCommercialService } from '../pricing-item/pricing-item-commercial-service';
import { singleton } from 'tsyringe';

@singleton()
export class QuoteServiceCorridorImpactService {
    constructor(
        private readonly pricingItemCorridorService: PricingItemCorridorService,
        private readonly pricingItemCommercialService: PricingItemCommercialService
    ) {
    }

    public applyLogisticPrice(quoteService: QuoteService, referential: any): void {
        let sumOfAllArticlesQtyAndCoeffFreq = new Big('0');
        this.forEachPricingItem(quoteService, pricingItem => {
            sumOfAllArticlesQtyAndCoeffFreq = this.pricingItemCorridorService.sumOfAllArticlesQtyAndCoeffFreq(pricingItem, sumOfAllArticlesQtyAndCoeffFreq, referential);
        });
        this.forEachPricingItem(quoteService, pricingItem => {
            if (!pricingItem.isCmc) {
                this.pricingItemCorridorService.applyLogisticsPriceToPricingItem(pricingItem, sumOfAllArticlesQtyAndCoeffFreq, quoteService.totalLogisticsPrice, referential);
            }
        });
    }

    public applyMepPrice(quoteService: QuoteService, referential: any): void {
        const contractDuration = parseBig(quoteService.contractInfoInputs?.contractDuration);
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.applyMepPriceToPricingItem(pricingItem, contractDuration, referential);
        });
    }

    public applyFreeMonthFactor(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.applyFreeMonthFactor(pricingItem, quoteService.factorFreeMonth);
        });
    }

    public applyContractVtFactor(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.applyContractVtFactor(pricingItem, quoteService.factorVt);
        });
    }

    public applyServiceStockSuppOffered(quoteService: QuoteService): void {
        if (!quoteService.contractInfoInputs?.isStockSuppOffered) {
            return;
        }
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.applyServiceStockSuppOffered(pricingItem, quoteService.contractInfoInputs?.contractDuration);
        });
    }

    public applyCorridorCustomCarpet(quoteService: QuoteService): void {
        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCommercialService.applyCorridorCustomCarpet(pricingItem);
        });
    }

    public applyWaterBottleDeliveryPrice(quoteService: QuoteService, referential: any): void {
        const waterDeliveryFactor: Big = quoteService.contractInfoInputs?.waterBottleDelivery === EnumWaterBottleDelivery.BONBONNES_DELIVERY_FONTAINE
            ? referential?.fontaineFootCoefficient?.value
            : referential?.centralStockCoefficient?.value;
        const isWaterBottleDeliveryWasChanged = quoteService.contractInfoInputs?.waterBottleDelivery !== quoteService.lastContractInfoInputs?.waterBottleDelivery
            || quoteService.lastContractInfoInputs?.waterBottleDelivery == undefined;

        this.forEachPricingItem(quoteService, pricingItem => {
            this.pricingItemCorridorService.applyWaterDeliveryFactorToPricingItem(pricingItem, waterDeliveryFactor, isWaterBottleDeliveryWasChanged);
        });
    }

    private forEachPricingItem(quoteService: QuoteService, callback: (pricingItem: PricingItem) => void): void {
        (quoteService.customGroups ?? []).forEach(customGroup => {
            (customGroup.pricingItems ?? []).forEach(callback);
        });
    }
}
